import { getEditorString, getNodeEntries, getPointBefore } from '@udecode/plate'
import { serialize } from '../../../BufferEditor'
import type { BufferEditor } from '../../../BufferEditor/types.plate'
import {
  type LinkedInAnnotationEntity,
  LinkedInAnnotationInputElement,
} from '../nodes'

function isDBEntry(
  entry: LinkedInAnnotationEntity | undefined,
): entry is LinkedInAnnotationEntity {
  return !!entry
}
// Find all linkedIn annotation elements in the editor
// and returns them in the format they're stored in the db.
// The returned entities are used again when loading the post to re-convert
// the annotation text into linkedIn annotation elements.
export const getAllLinkedInAnnotations = (
  editor: BufferEditor,
): LinkedInAnnotationEntity[] => {
  const nodeEntries = getNodeEntries<LinkedInAnnotationInputElement>(editor, {
    at: [],
    match: (n) => LinkedInAnnotationInputElement.is(n),
  })

  return Array.from(nodeEntries)
    .map(([node, path]): LinkedInAnnotationEntity | undefined => {
      const { autocompleted, valid } = node

      if (!getEditorString(editor, path)) {
        return undefined
      }

      const pointBefore = getPointBefore(editor, path)

      const entity = LinkedInAnnotationInputElement.toEntity(node)

      // Only return valid, autocompleted LinkedIn mentions
      // pointBefore can't be null or undefined, so adding it to condition here
      if (autocompleted && valid && entity && pointBefore) {
        const range = {
          anchor: { path: [0, 0], offset: 0 },
          focus: pointBefore,
        }

        const { text } = serialize(editor, {
          at: range,
        })
        const start = text.length
        const { length } = getEditorString(editor, path)

        return {
          ...entity,
          start,
          length,
        }
      }

      return undefined
    })
    .filter(isDBEntry)
}
